export const platformAccess = {
  junior: {
    required: [
      { platform: 'GitHub', access: 'Developer', purpose: 'Mobile repository access', setup: 'Request access to iOS and Android repos' },
      { platform: 'Jira', access: 'Developer', purpose: 'Mobile task tracking', setup: 'Account with mobile project access' },
      { platform: 'Slack', access: 'Member', purpose: 'Mobile team communication', setup: 'Join #mobile-team, #ios-development, #android-development' },
      { platform: 'Firebase Console', access: 'Viewer', purpose: 'Analytics and crash reports', setup: 'Request viewer access to mobile projects' }
    ],
    optional: [
      { platform: 'TestFlight', access: 'Tester', purpose: 'iOS beta testing', setup: 'Request TestFlight access for internal testing' },
      { platform: 'Google Play Console', access: 'Viewer', purpose: 'Android app monitoring', setup: 'Request read-only access' }
    ]
  },
  mid: {
    required: [
      { platform: 'App Store Connect', access: 'Developer', purpose: 'iOS app management', setup: 'Request developer role in App Store Connect' },
      { platform: 'Google Play Console', access: 'Developer', purpose: 'Android app management', setup: 'Request developer access' },
      { platform: 'Firebase Console', access: 'Editor', purpose: 'Mobile backend services', setup: 'Request editor permissions' },
      { platform: 'Crashlytics', access: 'Developer', purpose: 'Crash reporting and analysis', setup: 'Access through Firebase Console' }
    ],
    optional: [
      { platform: 'Fastlane Match', access: 'Developer', purpose: 'iOS certificate management', setup: 'Request access to certificate repository' },
      { platform: 'Mobile Device Lab', access: 'User', purpose: 'Physical device testing', setup: 'Request access to device testing lab' }
    ]
  },
  senior: {
    required: [
      { platform: 'App Store Connect', access: 'Admin', purpose: 'iOS team and app management', setup: 'Request admin role' },
      { platform: 'Google Play Console', access: 'Admin', purpose: 'Android team and app management', setup: 'Request admin permissions' },
      { platform: 'Firebase Console', access: 'Owner', purpose: 'Mobile platform management', setup: 'Request owner permissions' },
      { platform: 'Mobile CI/CD Platform', access: 'Admin', purpose: 'Build and deployment pipeline', setup: 'Admin access to mobile CI/CD' }
    ],
    optional: [
      { platform: 'Apple Developer Program', access: 'Team Agent', purpose: 'iOS development program management', setup: 'Request team agent role' },
      { platform: 'Google Play Developer', access: 'Account Owner', purpose: 'Android developer account management', setup: 'Request account ownership' }
    ]
  }
};
